class NessunSEConfigurator {
  constructor() {
    this.currentStep = 1;
    this.selectedPlans = new Set();
    this.selectedExtras = new Set();
    this.businessPlafond = null;
    this.animalTier = null;
    this.billingMode = 'monthly';
    this.init();
  }

  get cfg() {
    return window.nessunseConfiguratorData || null;
  }

  init() {
    if (!this.cfg) { alert('Configurazione mancante!'); return; }
    try {
      this._blockCartDrawer();
      this.injectLockBadges();
      this.attachEventListeners();
      this.addCardAnimationIndices();
      this.paintPricesToDOM();
      this.updateUI();
    } catch (err) {
      console.error('Errore init:', err);
    } finally {
      var container = document.querySelector('.nessunse-configurator');
      if (container) container.classList.add('loaded');
    }

    var self = this;
    var blockCount = 0;
    var blockInterval = setInterval(function() {
      self._blockCartDrawer();
      blockCount++;
      if (blockCount >= 10) clearInterval(blockInterval);
    }, 300);
  }

  injectLockBadges() {
    var lockSvg = '<svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/></svg>';
    var tooltip = 'Prossimamente disponibile';

    document.querySelectorAll('.plan-card--disabled, .extra-card--disabled').forEach(function(card) {
      if (card.querySelector('.card-lock-badge')) return;
      var badge = document.createElement('div');
      badge.className = 'card-lock-badge';
      badge.setAttribute('data-tooltip', tooltip);
      badge.innerHTML = lockSvg;
      card.appendChild(badge);
    });
  }

  addCardAnimationIndices() {
    document.querySelectorAll('.plan-card').forEach(function(c, i) { c.style.setProperty('--card-index', i); });
    document.querySelectorAll('.extra-card').forEach(function(c, i) { c.style.setProperty('--card-index', i); });
    document.querySelectorAll('.business-plafond-card').forEach(function(c, i) { c.style.setProperty('--card-index', i); });
    document.querySelectorAll('.animal-tier-card').forEach(function(c, i) { c.style.setProperty('--card-index', i); });
  }

  getPrice(key) {
    var cfg = this.cfg;
    var prop = this.billingMode === 'monthly' ? 'priceMonthly' : 'priceAnnual';
    if (cfg.plans && cfg.plans[key] && cfg.plans[key][prop] !== undefined) return cfg.plans[key][prop];
    if (cfg.extras && cfg.extras[key] && cfg.extras[key][prop] !== undefined) return cfg.extras[key][prop];
    if (key.indexOf('plafond-') === 0) {
      var p = key.replace('plafond-', '');
      if (cfg.businessPrices && cfg.businessPrices[p]) return cfg.businessPrices[p][this.billingMode] || 0;
    }
    if (key.indexOf('tier-') === 0) {
      var t = key.replace('tier-', '');
      if (cfg.animalPrices && cfg.animalPrices[t]) return cfg.animalPrices[t][this.billingMode] || 0;
    }
    return 0;
  }

  formatMoney(n) {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);
  }

  periodLabel() {
    return this.billingMode === 'monthly' ? '/mese' : '/anno';
  }

  paintPricesToDOM() {
    var self = this;
    var cfg = this.cfg;
    var pl = this.periodLabel();

    document.querySelectorAll('.plan-price-period, .extra-price-period, .plafond-price-period, .tier-price-period').forEach(function(el) {
      el.textContent = pl;
    });

    ['ME', 'FAMILY', 'JOB', 'DRIVER'].forEach(function(key) {
      var el = document.querySelector('[data-price="' + key + '"]');
      if (el) { var p = self.getPrice(key); el.textContent = p ? self.formatMoney(p) : '—'; }
    });

    // BUSINESS — "a partire da"
    var bizEl = document.querySelector('[data-price="BUSINESS"]');
    if (bizEl && cfg.businessPrices) {
      var minPrice = Infinity;
      for (var k in cfg.businessPrices) {
        var p = cfg.businessPrices[k][self.billingMode];
        if (p < minPrice) minPrice = p;
      }
      if (minPrice < Infinity) bizEl.innerHTML = '<span class="plan-price-prefix">a partire da</span>' + self.formatMoney(minPrice);
    }

    // ANIMAL — "a partire da"
    var animalEl = document.querySelector('[data-price="ANIMAL"]');
    if (animalEl && cfg.animalPrices) {
      var minA = Infinity;
      for (var k in cfg.animalPrices) {
        var p = cfg.animalPrices[k][self.billingMode];
        if (p < minA) minA = p;
      }
      if (minA < Infinity) animalEl.innerHTML = '<span class="plan-price-prefix">a partire da</span>' + self.formatMoney(minA);
    }

    if (cfg.businessPrices) {
      for (var plafond in cfg.businessPrices) {
        var el = document.querySelector('[data-price="plafond-' + plafond + '"]');
        if (el) el.textContent = self.formatMoney(cfg.businessPrices[plafond][self.billingMode]);
      }
    }

    if (cfg.animalPrices) {
      for (var tier in cfg.animalPrices) {
        var el = document.querySelector('[data-price="tier-' + tier + '"]');
        if (el) el.textContent = self.formatMoney(cfg.animalPrices[tier][self.billingMode]);
      }
    }

    for (var extraKey in cfg.extras) {
      if (cfg.extras[extraKey].disabled) continue;
      var el = document.querySelector('[data-price="' + extraKey + '"]');
      if (el) { var p = self.getPrice(extraKey); el.textContent = p ? self.formatMoney(p) : '—'; }
    }

    var lm = document.getElementById('cfg-lbl-month');
    var ly = document.getElementById('cfg-lbl-year');
    if (lm) lm.classList.toggle('billing-toggle-label--active', self.billingMode === 'monthly');
    if (ly) ly.classList.toggle('billing-toggle-label--active', self.billingMode === 'annual');
  }

  attachEventListeners() {
    var self = this;

    var bt = document.getElementById('cfg-billing-toggle');
    if (bt) {
      bt.addEventListener('change', function() {
        self.billingMode = this.checked ? 'annual' : 'monthly';
        self.paintPricesToDOM();
        self.updateSummary();
      });
    }

    document.querySelectorAll('.plan-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.plan-info-btn')) return;
        if (card.classList.contains('plan-card--disabled')) return;
        self.handlePlanSelection(e);
      });
    });

    document.querySelectorAll('.extra-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.extra-info-btn')) return;
        self.handleExtraSelection(e);
      });
    });

    document.querySelectorAll('.business-plafond-card').forEach(function(card) {
      card.addEventListener('click', function(e) { self.handleBusinessPlafondSelection(e); });
    });

    document.querySelectorAll('.animal-tier-card').forEach(function(card) {
      card.addEventListener('click', function(e) { self.handleAnimalTierSelection(e); });
    });

    document.querySelectorAll('[data-step-next]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { self.nextStep(e); });
    });
    document.querySelectorAll('[data-step-prev]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { self.prevStep(e); });
    });

    var co = document.querySelector('[data-checkout]');
    if (co) co.addEventListener('click', function(e) { self.handleCheckout(e); });

    document.querySelectorAll('.plan-info-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        self.openPlanModal(btn.getAttribute('data-plan-info'));
      });
    });

    document.querySelectorAll('.extra-info-btn').forEach(function(btn) {
      var icon = btn.querySelector('svg');
      if (!icon) return;
      icon.addEventListener('click', function(e) {
        e.stopPropagation();
        self.openExtraModal(btn.getAttribute('data-extra-info'));
      });
    });

    var overlay = document.getElementById('plan-info-overlay');
    var closeBtn = document.getElementById('plan-info-close');
    if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) self.closePlanModal(); });
    if (closeBtn) closeBtn.addEventListener('click', function() { self.closePlanModal(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') self.closePlanModal(); });
  }

  handlePlanSelection(e) {
    var card = e.currentTarget;
    var plan = card.dataset.plan;
    if (!plan || card.classList.contains('plan-card--disabled')) return;

    if (plan === 'ME' && this.selectedPlans.has('FAMILY')) {
      this.selectedPlans.delete('FAMILY');
      var fc = document.querySelector('[data-plan="FAMILY"]');
      if (fc) fc.classList.remove('selected');
    }
    if (plan === 'FAMILY' && this.selectedPlans.has('ME')) {
      this.selectedPlans.delete('ME');
      var mc = document.querySelector('[data-plan="ME"]');
      if (mc) mc.classList.remove('selected');
    }

    if (this.selectedPlans.has(plan)) {
      this.selectedPlans.delete(plan);
      card.classList.remove('selected');
      if (plan === 'BUSINESS') {
        this.businessPlafond = null;
        document.querySelectorAll('.business-plafond-card').forEach(function(c) { c.classList.remove('selected'); });
      }
      if (plan === 'ANIMAL') {
        this.animalTier = null;
        document.querySelectorAll('.animal-tier-card').forEach(function(c) { c.classList.remove('selected'); });
      }
    } else {
      this.selectedPlans.add(plan);
      card.classList.add('selected');
    }
    this.updateUI();
  }

  handleExtraSelection(e) {
    var card = e.currentTarget;
    var extra = card.dataset.extra;
    if (!extra || card.classList.contains('disabled') || card.classList.contains('extra-card--disabled') || card.classList.contains('included')) return;

    if (this.selectedExtras.has(extra)) {
      this.selectedExtras.delete(extra);
      card.classList.remove('selected');
    } else {
      this.selectedExtras.add(extra);
      card.classList.add('selected');
    }
    this.updateSummary();
  }

  handleBusinessPlafondSelection(e) {
    var card = e.currentTarget;
    var p = card.dataset.businessPlafond;
    document.querySelectorAll('.business-plafond-card').forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    this.businessPlafond = p;
    this.updateSummary();
  }

  handleAnimalTierSelection(e) {
    var card = e.currentTarget;
    var t = card.dataset.animalTier;
    document.querySelectorAll('.animal-tier-card').forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    this.animalTier = t;
    this.updateSummary();
  }

  updateUI() {
    var alertEl = document.querySelector('.configurator-alert');
    if (alertEl) alertEl.style.display = (this.selectedPlans.has('ME') || this.selectedPlans.has('FAMILY')) ? 'flex' : 'none';

    var businessBlock = document.querySelector('.business-special-block');
    if (businessBlock) businessBlock.style.display = this.selectedPlans.has('BUSINESS') ? 'block' : 'none';

    var animalBlock = document.querySelector('.animal-special-block');
    if (animalBlock) animalBlock.style.display = this.selectedPlans.has('ANIMAL') ? 'block' : 'none';

    if (!this.selectedPlans.has('BUSINESS')) {
      this.businessPlafond = null;
      document.querySelectorAll('.business-plafond-card').forEach(function(c) { c.classList.remove('selected'); });
    }
    if (!this.selectedPlans.has('ANIMAL')) {
      this.animalTier = null;
      document.querySelectorAll('.animal-tier-card').forEach(function(c) { c.classList.remove('selected'); });
    }

    this.updateExtrasAvailability();
    this.updateSummary();
  }

  updateExtrasAvailability() {
    var cfg = this.cfg;
    var self = this;
    var selectedPlans = Array.from(this.selectedPlans);

    // Caso speciale: ANIMAL come UNICO piano selezionato → nascondi gli extra non compatibili
    var animalOnly = selectedPlans.length === 1 && selectedPlans[0] === 'ANIMAL';
    var animalAllowed = (cfg.rules && cfg.rules.allowedExtras && cfg.rules.allowedExtras.ANIMAL) || [];

    var includedInPlan = {
      'tutela-circolazione': ['ME', 'FAMILY', 'DRIVER', 'BUSINESS'],
      'tutela-lavoro':       ['JOB', 'BUSINESS']
    };

    for (var extraKey in cfg.extras) {
      if (cfg.extras[extraKey].disabled) continue;
      var card = document.querySelector('[data-extra="' + extraKey + '"]');
      if (!card) continue;

      // Reset display dopo ogni passaggio (così se cambi piano i nascosti tornano visibili)
      card.style.display = '';

      // ── CASO ANIMAL SOLO: nascondi tutti gli extra non in ANIMAL allowedExtras ──
      if (animalOnly) {
        if (animalAllowed.indexOf(extraKey) === -1) {
          card.style.display = 'none';
          card.classList.remove('selected', 'disabled', 'included');
          self.selectedExtras.delete(extraKey);
          var badge = card.querySelector('.extra-included-badge');
          if (badge) badge.style.display = 'none';
          continue;
        } else {
          // RC capofamiglia visibile e pulita
          card.classList.remove('disabled', 'included');
          var badge = card.querySelector('.extra-included-badge');
          if (badge) badge.style.display = 'none';
          continue;
        }
      }

      // ── LOGICA NORMALE (anche per ANIMAL + altri piani) ──
      var includedPlans = includedInPlan[extraKey] || [];
      var isIncluded = selectedPlans.length > 0 && selectedPlans.some(function(plan) {
        return includedPlans.indexOf(plan) !== -1;
      });

      if (isIncluded) {
        card.classList.add('included');
        card.classList.remove('disabled', 'selected');
        self.selectedExtras.delete(extraKey);
        var badge = card.querySelector('.extra-included-badge');
        if (badge) badge.style.removeProperty('display');
        continue;
      } else {
        card.classList.remove('included');
        var badge = card.querySelector('.extra-included-badge');
        if (badge) badge.style.display = 'none';
      }

      if (selectedPlans.length === 0) {
        card.classList.remove('disabled');
        continue;
      }

      // Un extra è selezionabile se ALMENO UN piano selezionato lo supporta
      // (es. ANIMAL+BUSINESS, Soccorso Stradale: ANIMAL non lo whitelista ma BUSINESS sì → selezionabile)
      var allowed = selectedPlans.some(function(plan) {
        var planExtras = cfg.rules && cfg.rules.allowedExtras && cfg.rules.allowedExtras[plan];
        return planExtras && planExtras.indexOf(extraKey) !== -1;
      });

      if (!allowed) {
        card.classList.add('disabled');
        card.classList.remove('selected');
        self.selectedExtras.delete(extraKey);
      } else {
        card.classList.remove('disabled');
      }
    }

    // Toggle classe extras-grid--single quando una sola card è visibile (per centrare il layout)
    var grid = document.querySelector('.extras-grid');
    if (grid) {
      var allCards = grid.querySelectorAll('.extra-card');
      var visibleCount = 0;
      allCards.forEach(function(c) { if (c.style.display !== 'none') visibleCount++; });
      grid.classList.toggle('extras-grid--single', visibleCount === 1);
    }
  }

  _forceCardVisibility(step) {
    var stepEl = document.querySelector('[data-step="' + step + '"]');
    if (!stepEl) return;
    stepEl.querySelectorAll('.extra-card, .business-plafond-card, .animal-tier-card, .plan-card').forEach(function(card) {
      card.style.opacity = '1';
    });
  }

  nextStep(e) {
    e.preventDefault();
    if (this.currentStep === 1 && this.selectedPlans.size === 0) { alert('Seleziona almeno un abbonamento per continuare'); return; }
    if (this.currentStep === 2 && this.selectedPlans.has('BUSINESS') && !this.businessPlafond) { alert('Seleziona un Plafond BUSINESS per continuare'); return; }
    if (this.currentStep === 2 && this.selectedPlans.has('ANIMAL') && !this.animalTier) { alert('Seleziona il numero di animali per continuare'); return; }
    this.currentStep++;
    this.showStep(this.currentStep);
  }

  prevStep(e) {
    e.preventDefault();
    this.currentStep--;
    this.showStep(this.currentStep);
  }

  showStep(step) {
    document.querySelectorAll('.configurator-step').forEach(function(s) { s.classList.remove('active'); });
    var stepEl = document.querySelector('[data-step="' + step + '"]');
    if (stepEl) stepEl.classList.add('active');
    var sc = document.querySelector('.step-current');
    if (sc) sc.textContent = step;
    if (step === 3) this.updateSummary();

    var self = this;
    setTimeout(function() {
      self._forceCardVisibility(step);
    }, 50);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  updateSummary() {
    var summaryPlans = document.querySelector('.summary-plans');
    var summaryExtras = document.querySelector('.summary-extras');
    var summaryTotal = document.querySelector('.summary-total');
    if (!summaryPlans || !summaryExtras || !summaryTotal) return;

    var self = this;
    var total = 0;
    var plansHtml = '';
    var extrasHtml = '';
    var pl = this.periodLabel();

    this.selectedPlans.forEach(function(plan) {
      if (plan === 'BUSINESS' || plan === 'ANIMAL') return;
      var price = self.getPrice(plan);
      total += price;
      plansHtml += '<div class="summary-item"><span class="summary-item-name">' + (self.cfg.plans[plan].displayName || plan) + '</span><span class="summary-item-price">' + self.formatMoney(price) + pl + '</span></div>';
    });

    if (this.selectedPlans.has('BUSINESS') && this.businessPlafond) {
      var bPrice = this.getPrice('plafond-' + this.businessPlafond);
      total += bPrice;
      var plafondLabel = parseInt(this.businessPlafond, 10).toLocaleString('it-IT');
      plansHtml += '<div class="summary-item summary-special-business"><span class="summary-item-name">NessunSe BUSINESS (Plafond €' + plafondLabel + ')</span><span class="summary-item-price">' + self.formatMoney(bPrice) + pl + '</span></div>';
    }

    if (this.selectedPlans.has('ANIMAL') && this.animalTier) {
      var aPrice = this.getPrice('tier-' + this.animalTier);
      total += aPrice;
      var tierLabel = this.animalTier === '1' ? '1 Animale' : (this.animalTier + ' Animali');
      plansHtml += '<div class="summary-item summary-special-animal"><span class="summary-item-name">NessunSe ANIMAL (' + tierLabel + ')</span><span class="summary-item-price">' + self.formatMoney(aPrice) + pl + '</span></div>';
    }

    summaryPlans.innerHTML = plansHtml || '<p class="summary-empty">Nessun abbonamento selezionato</p>';

    this.selectedExtras.forEach(function(extra) {
      var price = self.getPrice(extra);
      total += price;
      extrasHtml += '<div class="summary-item"><span class="summary-item-name">' + (self.cfg.extras[extra].displayName || extra) + '</span><span class="summary-item-price">' + self.formatMoney(price) + pl + '</span></div>';
    });

    summaryExtras.innerHTML = extrasHtml || '<p class="summary-empty">Nessun extra selezionato</p>';

    var totalLabel = this.billingMode === 'monthly' ? 'Totale mensile:' : 'Totale annuale:';
    summaryTotal.innerHTML = '<div class="summary-total-main"><span>' + totalLabel + '</span><strong>' + self.formatMoney(total) + pl + '</strong></div>';
  }

  _checkSvg() {
    return '<svg class="modal-check" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';
  }

  openPlanModal(plan) {
    var data = {
      ME: {
        title: 'NessunSe ME', color: 'me',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/me.jpg?v=1767887850',
        items: [
          'Consulenza illimitata in modalità telefonica o videoconferenza',
          'Assistenza legale civile per separazioni, testamenti, danni e controversie con terzi',
          'Assistenza legale penale per reati contro la persona e il patrimonio',
          'Assistenza fiscale per questioni tributarie, successioni e rateazioni',
          'Supporto per perizie tecniche e medico-legali',
          'Plafond illimitato senza franchigie, esclusioni o scoperti',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla conclusione'
        ]
      },
      FAMILY: {
        title: 'NessunSe FAMILY', color: 'family',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/family.jpg?v=1767887839',
        items: [
          'Consulenza illimitata telefonica o in videoconferenza per te e i membri della tua famiglia',
          'Tutela legale civile e penale per fatti legati alla vita familiare, proprietà, responsabilità personali, danni a terzi e reati contro la persona o il patrimonio',
          'Assistenza fiscale, peritale e medico-legale',
          'Plafond illimitato, senza franchigie, esclusioni o scoperti',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla loro conclusione'
        ]
      },
      JOB: {
        title: 'NessunSe JOB', color: 'job',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/job.jpg?v=1767887847',
        items: [
          'Consulenza legale illimitata in diritto del lavoro, previdenziale e sindacale',
          'Tutela legale in caso di controversie con il datore di lavoro o per recupero crediti di lavoro',
          'Assistenza in procedure di conciliazione e riconoscimento di mansioni o ore straordinarie',
          'Consulenza e supporto per diritto risarcitorio relativo a infortuni sul lavoro',
          'Compilazione e invio del 730 e richiesta ISEE',
          'Plafond illimitato, senza franchigie, esclusioni o scoperti',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla loro conclusione'
        ]
      },
      DRIVER: {
        title: 'NessunSe DRIVER', color: 'driver',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/driver.jpg?v=1767887832',
        items: [
          'Consulenza legale illimitata telefonica o in videoconferenza',
          'Tutela civile e penale per fatti avvenuti durante la circolazione stradale (in ambito nazionale ed europeo) e nautica (in acque nazionali)',
          'Plafond illimitato, senza franchigie, esclusioni o scoperti',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla loro conclusione'
        ]
      },
      BUSINESS: {
        title: 'NessunSe BUSINESS', color: 'business',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/business.jpg?v=1767887812',
        items: [
          'Consulenza legale illimitata in tutte le aree del diritto aziendale, fiscale e del lavoro',
          'Tutela civile per contratti, recupero crediti, vertenze aziendali e danni a cose o persone',
          'Assistenza penale d\'impresa, compresi reati societari, tributari, fallimentari e responsabilità penale aziendale',
          'Supporto fiscale e tributario per contenziosi, piani di rateazione e verifiche debitorie',
          'Redazione di perizie su fabbricati e mezzi a motore, e perizie medico-legali per danni fisici',
          'Tutela legale per la circolazione stradale quando l\'azienda è coinvolta come parte passiva',
          'Assistenza nel passaggio e ricambio generazionale di proprietà, gestione o controllo aziendale',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla loro conclusione'
        ]
      },
      ANIMAL: {
        title: 'NessunSe ANIMAL', color: 'animal',
        icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/animal.jpg?v=1767887827',
        items: [
          'Consulenza illimitata per i proprietari di animali domestici regolarmente dotati di microchip, in modalità telefonica o videoconferenza',
          'Controversie condominiali legate alla detenzione dell\'animale',
          'Maltrattamenti subiti, smarrimento, contenziosi sull\'adozione',
          'Disservizi da parte di strutture veterinarie o servizi pet',
          'Problematiche per eventi causati o subiti dall\'animale nella vita quotidiana',
          'Contributo di € 200,00 per spese di cremazione (su attestazione del decesso e fattura)',
          'Plafond illimitato, senza franchigie, esclusioni o scoperti',
          'Copertura fino a € 2.000 per spese di soccombenza',
          'Prosecuzione delle pratiche anche oltre la scadenza annuale fino alla loro conclusione'
        ]
      }
    };
    var d = data[plan];
    if (!d) return;
    this._showModal(d.title, d.color, d.icon, d.items);
  }

  openExtraModal(extra) {
    var data = {
      'rc-capofamiglia': {
        title: 'R.C. Capofamiglia', color: 'extra', icon: null,
        items: [
          'Copertura danni a terzi tramite convenzione con Primaria Compagnia Assicurativa',
          'Massimale fino a € 500.000,00',
          'Nessuna franchigia, nessuna esclusione, nessuno scoperto'
        ]
      },
      'tutela-lavoro': {
        title: 'Tutela Diritto del Lavoro', color: 'extra', icon: null,
        items: [
          'Assistenza legale in diritto del lavoro, previdenziale e sindacale',
          'Impugnazione licenziamenti individuali e collettivi',
          'Procedure di conciliazione e recupero crediti di lavoro',
          'Riconoscimento mansioni superiori e ore straordinarie',
          'Diritto risarcitorio per danni da infortuni sul lavoro'
        ]
      },
      'soccorso-stradale': {
        title: 'Soccorso Stradale', color: 'extra', icon: null,
        items: [
          'Rimborso spese di soccorso stradale e recupero del mezzo (auto, moto, natante). Rimborso fino a € 200,00 annui in caso di guasto meccanico, incidente o incendio',
          'Valido su tutto il territorio nazionale'
        ]
      },
      'tutela-circolazione': {
        title: 'Tutela Circolazione Stradale', color: 'extra', icon: null,
        items: [
          'Tutela legale civile per vertenze legate alla circolazione stradale (nazionale ed europea)',
          'Copertura per circolazione nautica in acque nazionali',
          'Assistenza per incidenti, infrazioni e contenziosi stradali'
        ]
      }
    };
    var d = data[extra];
    if (!d) return;
    this._showModal(d.title, d.color, d.icon, d.items);
  }

  _showModal(title, colorClass, iconUrl, items) {
    var overlay = document.getElementById('plan-info-overlay');
    var modal = document.getElementById('plan-info-modal');
    var titleEl = document.getElementById('plan-info-modal-title');
    var iconEl = document.getElementById('plan-info-modal-icon');
    var listEl = document.getElementById('plan-info-modal-list');
    if (!overlay || !modal || !titleEl || !listEl) return;

    var self = this;
    modal.className = 'plan-info-modal plan-info-modal--' + colorClass;
    titleEl.textContent = title;
    iconEl.innerHTML = iconUrl
      ? '<img src="' + iconUrl + '" style="width:36px;height:36px;border-radius:8px;object-fit:contain;" alt="">'
      : '<svg width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#1b454f"/><text x="18" y="24" text-anchor="middle" font-family="Georgia,serif" font-size="20" font-weight="700" fill="#fff">i</text></svg>';

    listEl.innerHTML =
      '<p class="plan-info-modal__section-label">Alcuni esempi di cosa comprende</p>' +
      items.map(function(item) {
        return '<li>' + self._checkSvg() + '<span>' + item + '</span></li>';
      }).join('');

    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  closePlanModal() {
    var overlay = document.getElementById('plan-info-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  _blockCartDrawer() {
    var sel = 'cart-drawer,cart-notification,.cart-drawer,.cart-popup,.cart-notification,.mini-cart,.ajax-cart,#cart-drawer,#CartDrawer,#mini-cart,[id*="cart-drawer"],[class*="CartDrawer"],.CartDrawer,.cart-sidebar';
    try {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.removeAttribute('open');
        el.classList.remove('is-open', 'active', 'open', 'drawer--is-open');
      });
    } catch(e) {}
    document.body.classList.remove('overflow-hidden', 'cart-is-open', 'drawer-is-open', 'js-drawer-open', 'cart-open', 'no-scroll');
    document.documentElement.classList.remove('overflow-hidden', 'js-drawer-open');
  }

  async handleCheckout(e) {
    e.preventDefault();
    if (this.selectedPlans.size === 0) { alert('Seleziona almeno un abbonamento per procedere.'); return; }
    if (this.selectedPlans.has('BUSINESS') && !this.businessPlafond) { alert('Seleziona un Plafond BUSINESS prima di procedere.'); return; }
    if (this.selectedPlans.has('ANIMAL') && !this.animalTier) { alert('Seleziona il numero di animali prima di procedere.'); return; }

    var cfg = this.cfg;
    var items = [];
    var isAnnual = this.billingMode === 'annual';

    this.selectedPlans.forEach(function(plan) {
      if (plan === 'BUSINESS' || plan === 'ANIMAL') return;
      var planCfg = cfg.plans[plan];
      if (!planCfg || planCfg.disabled) return;
      var variantId = planCfg.variantId;
      var sellingPlan = isAnnual ? planCfg.sellingPlanAnnual : planCfg.sellingPlanMonthly;
      if (variantId && sellingPlan) items.push({ id: Number(variantId), quantity: 1, selling_plan: sellingPlan });
    });

    if (this.selectedPlans.has('BUSINESS') && this.businessPlafond) {
      var bVarId = cfg.businessVariantIds[this.businessPlafond];
      var bSp = isAnnual ? cfg.plans.BUSINESS.sellingPlanAnnual : cfg.plans.BUSINESS.sellingPlanMonthly;
      if (bVarId && bSp) items.push({ id: Number(bVarId), quantity: 1, selling_plan: bSp });
    }

    if (this.selectedPlans.has('ANIMAL') && this.animalTier) {
      var aVarId = cfg.animalVariantIds[this.animalTier];
      var aSp = isAnnual ? cfg.plans.ANIMAL.sellingPlanAnnual : cfg.plans.ANIMAL.sellingPlanMonthly;
      if (aVarId && aSp) items.push({ id: Number(aVarId), quantity: 1, selling_plan: aSp });
    }

    this.selectedExtras.forEach(function(extraKey) {
      var extraCfg = cfg.extras[extraKey];
      if (!extraCfg || extraCfg.disabled) return;
      var variantId = extraCfg.variantId;
      var sellingPlan = isAnnual ? extraCfg.sellingPlanAnnual : extraCfg.sellingPlanMonthly;
      if (variantId && sellingPlan) items.push({ id: Number(variantId), quantity: 1, selling_plan: sellingPlan });
    });

    if (items.length === 0) { alert('Errore: nessun prodotto da aggiungere al carrello.'); return; }

    try {
      this._blockCartDrawer();
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      this._blockCartDrawer();
      var data = await response.json();
      if (!response.ok) { alert(data.description || data.message || 'Errore durante l\'aggiunta al carrello'); return; }
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Errore checkout:', error);
      alert('Errore di connessione. Riprova.');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  window.configurator = new NessunSEConfigurator();
  setTimeout(function() {
    var container = document.querySelector('.nessunse-configurator');
    if (container) container.classList.add('loaded');
  }, 500);
});